import { message } from "antd";
import axiosInstance from "../axiosInstance";

import {
	FETCH_SPINS_REQUEST,
	FETCH_SPINS_SUCCESS,
	FETCH_SPINS_FAIL,
	FETCH_SPIN_REQUEST,
	FETCH_SPIN_SUCCESS,
	FETCH_SPIN_FAIL,
	DOWNLOAD_SPINS_REQUEST,
	DOWNLOAD_SPINS_SUCCESS,
	DOWNLOAD_SPINS_FAIL,
} from "../constants/spinTheWheelOverview";
import { RESET_DOWNLOAD_CSV } from "../constants/survey";

const fetchSpins = (params) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	let url = null;
	if (params) {
		if (params.filter) {
			let filterParams = handleFilterParams(params.filter);
			url = `/admin/spins?page=${params.start}&count=${
				params.count
			}&${filterParams.join("&")}`;
		} else {
			url = `/admin/spins?page=${params.start}&count=${params.count}`;
		}
	} else {
		url = "/admin/spins";
	}
	dispatch({ type: FETCH_SPINS_REQUEST });
	try {
		const { data } = await axiosInstance.get(url, {
			params,
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});
		dispatch({
			type: FETCH_SPINS_SUCCESS,
			payload: data,
		});
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		dispatch({ type: FETCH_SPINS_FAIL, payload: errorMessage });
	}
};

const fetchSpin = (id) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: FETCH_SPIN_REQUEST });
	console.log(id);
	console.log(adminInfo);
	try {
		const { data } = await axiosInstance.get(`/admin/spins/${id}`, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		dispatch({ type: FETCH_SPIN_SUCCESS, payload: data.data });
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: FETCH_SPIN_FAIL, payload: errorMessage });
	}
};

const handleFilterParams = (params) => {
	let result = [];
	for (let item of Object.keys(params)) {
		if (params[item]) {
			result.push(`filter[${item}]=${params[item]}`);
		}
	}
	return result;
};

const exportSpins = (params) => async (dispatch, getState) => {
	console.log("params ", params);
	const {
		login: { adminInfo },
	} = getState();
	let url = null;
	if (params && params.filter) {
		let filterParams = handleFilterParams(params.filter);
		url = `/admin/spins/download?${filterParams.join("&")}`;
	} else {
		url = `/admin/spins/download`;
	}
	dispatch({ type: DOWNLOAD_SPINS_REQUEST });
	try {
		const { data } = await axiosInstance.get(url, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		dispatch({
			type: DOWNLOAD_SPINS_SUCCESS,
			payload: data,
		});
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		dispatch({ type: DOWNLOAD_SPINS_FAIL, payload: errorMessage });
	}
};

const resetDownloadCsv = () => (dispatch) => {
	dispatch({ type: RESET_DOWNLOAD_CSV });
};

export { fetchSpins, fetchSpin, exportSpins, resetDownloadCsv };
